// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zapdos: PokeData = {
  "id": 145,
  "name": "zapdos",
  "height": 16,
  "weight": 526,
  "base_experience": 261,
  "types": [
    PokeType.ELECTRIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "leer",
    "peck",
    "drill-peck",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "agility",
    "light-screen",
    "sky-attack",
    "zap-cannon",
    "detect",
    "rain-dance",
    "ancient-power",
    "charge",
    "roost",
    "pluck",
    "discharge",
    "magnetic-flux"
  ],
  "moves": [
    "leer",
    "peck",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "sky-attack",
    "zap-cannon",
    "rain-dance",
    "ancient-power",
    "roost",
    "air-slash",
    "electric-terrain",
    "chatter"
  ],
  "evolution_chain": {
    "id": 74,
    "item": null,
    "species": [
      {
        "name": "zapdos",
        "order": 177,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 113,
    "speed": 127,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
